import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  zIndex: 11111,
  backgroundColor: (p) => `${p.palette.grey[700]}80`, // 50% opacity
  color: (p) => p.palette.common.white,
};
